(function() {
    if (window.chrome) {
        bindInstallButtonClicks();
    }

    var chromeURL = 'https://chrome.google.com/webstore/detail/pkojccpfacognnfgbafojnnlkeifcmhe';

    if (window.Bookindy) {
        Bookindy.locateStore({maxDistance: 50}).then(function (store) {
            if (store) {
                var el = document.getElementById('Header-body');
                el.innerHTML = `Browse Amazon, buy from <a href="${store.url}">${store.name} (${store.distance} miles away)</a>.`;
            }
        });
    }

    function bindInstallButtonClicks () {
        var btns = [].slice.call(document.querySelectorAll('[data-install-button]'), 0);
        btns.forEach(function (el) {
            el.addEventListener('click', onInstallClick);
        });
    }

    function onInstallComplete () {
        var btns = [].slice.call(document.querySelectorAll('[data-install-button]'), 0);
        btns.forEach(function (el) {
            el.children[0].innerHTML = el.dataset.installedCopy;
            el.classList.remove('Button--plus');
            el.removeEventListener('click', onInstallClick);
        });
    }

    function unBindInstallHandlers () {
        var btns = [].slice.call(document.querySelectorAll('[data-install-button]'), 0);
        btns.forEach(function (el) {
            el.removeEventListener('click', onInstallClick);
        });
    }

    function onInstallClick (e) {
        e.preventDefault();
        chrome.webstore.install(chromeURL, onInstallComplete, function (msg, err) {
            if (err !== 'userCancelled') {
                window.location = chromeURL;
            }
        });
    }
})();
